import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class StatusModel extends BaseModel {

    constructor() {
        super({
                name: "status",
                tableName: 'status',
                label: "Trạng thái",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                type: {
                    name: "type",
                    display: false
                },
                code: {
                    name: "code",
                    display: false
                },
                name:{
                    name: "name",
                    label: "Tên công việc",
                    type: "String",
                    class: "center",
                    display: false
                },
                deledted: {
                    name: "deleted",
                    display: false
                },
            },
            )
    }

}